// src/utils/analytics.js
import { Capacitor } from '@capacitor/core';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics';

/**
 * Servicio centralizado para el registro de eventos de analítica.
 * Soporta tanto plataformas nativas (vía Capacitor Plugin) como Web (vía Firebase SDK si se requiere).
 */

const isNative = Capacitor.isNativePlatform();

/**
 * Registra un evento de analítica.
 * @param {string} name - Nombre del evento (ej: 'login', 'view_page')
 * @param {Object} params - Parámetros adicionales del evento
 */
export const logEvent = async (name, params = {}) => {
    try {
        if (isNative) {
            await FirebaseAnalytics.logEvent({
                name,
                params,
            });
            console.log(`[Analytics-Native] Event: ${name}`, params);
        } else {
            // Opcional: Implementar analítica web con el SDK de Firebase si fuera necesario
            console.log(`[Analytics-Web-Simulation] Event: ${name}`, params);
        }
    } catch (error) {
        console.error('Error al registrar evento de analítica:', error);
    }
};

/**
 * Configura el ID de usuario para el rastreo.
 * @param {string} userId - ID único del usuario
 */
export const setAnalyticsUser = async (userId) => {
    if (!userId) return;
    try {
        if (isNative) {
            await FirebaseAnalytics.setUserId({ userId });
        }
    } catch (error) {
        console.error('Error al configurar usuario de analítica:', error);
    }
};

/**
 * Registra la vista de una pantalla o sección.
 * @param {string} screenName - Nombre de la pantalla
 */
export const logPageView = async (screenName) => {
    return logEvent('screen_view', {
        firebase_screen: screenName,
        firebase_screen_class: screenName
    });
};
